import React, { useContext, useState } from "react";
import cs from "classnames";
import { ExpandBox } from "../../components/ExpandBox";
import { FormGroup } from "../../components/FormGroup";
import { WeFitStepSliderBlock } from "../WeFitStepSliderBlock";
import {
  ChoiceLayout,
  ChoiceTypes,
  PageQuestion,
  PageQuestionOption,
} from "../../types/hexpertTypes";
import { HexpertContext, THexpertAnswer } from "../../contexts/HexPertProvider";
import { ButtonMapper } from "../../components/Buttons";
import './WeFitChoiceBlock.scss';

export const WeFitChoiceBlock = (props: PageQuestion) => {
  const {
    Label,
    Options,
    conditionQuestions,
    Tooltip,
    CheckboxType,
    CheckboxOrientation,
    FieldId,
  } = props;
  const { state, dispatch } = useContext(HexpertContext);
  const [selected, setSelected] = useState<PageQuestionOption>(
    Options?.find((item) => item.Value === state?.formAnswers?.[FieldId])
  );
  const [localPrevChildSelected, setLocalPrevChildSelected] =
    useState<THexpertAnswer | null>(null);

  if (CheckboxType === ChoiceTypes.SLIDER) {
    return <WeFitStepSliderBlock steps={Options} Label={Label} {...props} />;
  }
  const handleExpandButtonClick = (item: PageQuestionOption) => {
    const conditionFieldIds = conditionQuestions?.filter((condition) => {
      return condition.Conditions.every((condition) => {
        return condition.FieldValue !== item.Value;
      });
    });
    if (conditionFieldIds?.length > 0) {
      conditionFieldIds.forEach((fieldId) =>
        dispatch({ type: "removeAnswer", payload: fieldId.FieldId })
      );
    }

    const tempAnswer = { [FieldId]: item.Value };
    conditionQuestions?.forEach((condition) => {
      if (
        !conditionFieldIds?.includes(condition) &&
        !state?.formAnswers?.[condition?.FieldId]
      ) {
        const conditionDefault = condition?.Options?.find((op) => op.Checked);

        if (localPrevChildSelected?.[condition?.FieldId]) {
          dispatch({
            type: "setAnswer",
            payload: {
              [condition.FieldId]: localPrevChildSelected[condition?.FieldId],
            },
          });
        } else if (conditionDefault) {
          tempAnswer[condition?.FieldId] = conditionDefault?.Value;
          dispatch({
            type: "setAnswer",
            payload: tempAnswer,
          });
        }
      }
    });

    dispatch({
      type: "setAnswer",
      payload: tempAnswer,
    });
    setSelected(item);
  };

  return conditionQuestions && conditionQuestions?.length > 0 ? (
    <FormGroup title={Label} tooltip={Tooltip}>
      <div
        className={cs("c-hex-choice-block-container", {
          "c-hex-choice-block-container--column":
            CheckboxOrientation === ChoiceLayout.VERTICAL,
          "c-hex-choice-block-container--nowrap":
            CheckboxType === ChoiceTypes.LARGE_BUTTON,
        })}
      >
        {Options?.map((item) => (
          <ButtonMapper
            key={item.Value}
            name={Label}
            type={CheckboxType}
            action={() => {
              handleExpandButtonClick(item);
              if (item.Value !== state?.formAnswers?.[FieldId]) {
              }
            }}
            selected={
              state?.formAnswers && item.Value === state?.formAnswers?.[FieldId]
            }
            props={item}
          />
        ))}
      </div>

      <ExpandBox expand={Boolean(selected)}>
        <div
          className={cs(
            "c-hex-choice-block-container c-hex-choice-block-container-expand c-hex-choice-block-container-gap--32",
            {
              "c-hex-choice-block-container--column":
                conditionQuestions?.length > 0 &&
                conditionQuestions[0].CheckboxOrientation ===
                ChoiceLayout.VERTICAL,
              "c-hex-choice-block-container--nowrap":
                CheckboxType === ChoiceTypes.LARGE_BUTTON,
            }
          )}
        >
          {selected &&
            conditionQuestions
              ?.filter((child) =>
                child.Conditions?.some(
                  (condition) =>
                    condition.Operation === "Equals" &&
                    condition.FieldValue === selected.Value
                )
              )
              ?.map((child, i) => {
                return (
                  <div key={i} className={"c-hex-choice-expand-options"}>
                    <p className={"c-hex-choice-expand-options-title"}>
                      {child?.Label}
                    </p>
                    {child?.Options?.map((optionChild) => {
                      const hasDefault = optionChild?.Checked;
                      if (
                        hasDefault &&
                        !state?.formAnswers[child?.FieldId] &&
                        !localPrevChildSelected?.[child?.FieldId]
                      ) {
                        dispatch({
                          type: "setAnswer",
                          payload: { [child.FieldId]: optionChild.Value },
                        });
                      }
                      return (
                        <ButtonMapper
                          key={optionChild.Value}
                          name={child.Label}
                          type={ChoiceTypes.RADIO}
                          action={() => {
                            dispatch({
                              type: "setAnswer",
                              payload: { [child.FieldId]: optionChild.Value },
                            });
                            setLocalPrevChildSelected((prev) => ({
                              ...prev,
                              [child.FieldId]: optionChild.Value,
                            }));
                          }}
                          props={optionChild}
                          selected={
                            state?.formAnswers &&
                            optionChild.Value ===
                            state?.formAnswers?.[child?.FieldId]
                          }
                        />
                      );
                    })}
                  </div>
                );
              })}
        </div>
      </ExpandBox>
    </FormGroup>
  ) : (
    <FormGroup title={Label}>
      <div
        className={cs("c-hex-choice-block-container", {
          "c-hex-choice-block-container--column":
            CheckboxOrientation === ChoiceLayout.VERTICAL,
          "c-hex-choice-block-container--nowrap":
            CheckboxType === ChoiceTypes.LARGE_BUTTON,
        })}
      >
        {Options?.map((item) => {
          return (
            <ButtonMapper
              type={CheckboxType}
              name={Label}
              key={item.Value}
              action={() =>
                dispatch({
                  type: "setAnswer",
                  payload: { [FieldId]: item.Value },
                })
              }
              selected={
                state?.formAnswers &&
                item.Value === state?.formAnswers?.[FieldId]
              }
              props={item}
            />
          );
        })}
      </div>
    </FormGroup>
  );
};
